// extracted by mini-css-extract-plugin
export default {"root":"Help_root__mUbEj","ant-popover-arrow":"Help_ant-popover-arrow__W9asP","icon":"Help_icon__7lzWz"};